import { render, staticRenderFns } from "./function-btns.vue?vue&type=template&id=ba725bf6&scoped=true"
import script from "./function-btns.vue?vue&type=script&lang=js"
export * from "./function-btns.vue?vue&type=script&lang=js"
import style0 from "./function-btns.vue?vue&type=style&index=0&id=ba725bf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba725bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba725bf6')) {
      api.createRecord('ba725bf6', component.options)
    } else {
      api.reload('ba725bf6', component.options)
    }
    module.hot.accept("./function-btns.vue?vue&type=template&id=ba725bf6&scoped=true", function () {
      api.rerender('ba725bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/function-btns.vue"
export default component.exports